import { usePagination } from 'noddi-ui-web';
import { useNotificationOverviewMembers } from './useNotificationOverviewMembers';

export type DriverCandidates = ReturnType<typeof useDriverCandidates>;

/**
 * The car sheet's member list. Held by the sheet rather than the picker so it stays
 * mounted through the review, where "Turn on SMS" refetches it and the picked row with it.
 */
export const useDriverCandidates = (userGroupId: number) => {
  const { pagination, setPagination, search, setSearch } = usePagination();
  const { data, isFetching, error } = useNotificationOverviewMembers(userGroupId, pagination);

  return {
    pagination,
    setPagination,
    search,
    setSearch,
    members: data?.results ?? [],
    totalCount: data?.count,
    isFetching,
    error
  };
};
